import { IconClose } from '@shared/icons'
import { Button } from '@shared/innmaxUI/Form'
import styled from 'styled-components'

export type ISecondarySidebarProps = {
  visible: boolean
  onClose?: () => void
  headerMoreAction?: React.ReactNode
}

const SecondarySidebar = (
  props: React.PropsWithChildren<ISecondarySidebarProps>
) => {
  return props.visible ? (
    <Div visible={props.visible}>
      <div className="px-[10px] flex justify-between items-center mb-15 min-h-[32px]">
        <Button
          type="icon"
          icon={<IconClose color={'#fff'} />}
          onClick={props.onClose}
          className=""
        />
        {props.headerMoreAction}
      </div>
      {props.children}
    </Div>
  ) : null
}

export default SecondarySidebar

const Div = styled.div<{ visible: boolean }>`
  grid-area: secondary-sidebar;
  margin-top: 34px;
  pointer-events: auto;
  width: ${p => (p.visible ? '250px' : '0px')};
  height: auto;
  word-break: keep-all;
  white-space: nowrap;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba(39, 39, 39, 0.9);
  transition: width 0.3s;
  display: flex;
  flex-direction: column;
  > * {
    opacity: ${p => (p.visible ? 1 : 0)};
    transition: opacity 0.2s;
  }
`
